import { getInspModels } from "common-lib";
import { InspModelItem } from "@types";

// /ai/models는 모달 하나 열 때 여러 컴포넌트(DefectPreview, SelectionInspModel, useParsedModels …)가
// 제각각 호출한다. 짧은 시간 안의 중복 호출은 같은 응답을 공유한다.
// ponytail: 단순 TTL 캐시. 목록이 바뀌는 동작(모델 저장/삭제) 뒤에는 invalidateInspModels()를 부른다
const TTL = 3000;
let cache: { at: number; p: Promise<InspModelItem[]> } | null = null;

export const fetchInspModels = (): Promise<InspModelItem[]> => {
  if (!cache || Date.now() - cache.at > TTL) {
    const p = getInspModels().catch((error: any) => {
      cache = null;
      throw error;
    });
    cache = { at: Date.now(), p };
  }
  return cache.p;
};

export const invalidateInspModels = () => {
  cache = null;
};

export const parseInfo = (info?: string | null): any => {
  try {
    return JSON.parse(info!!) ?? {};
  } catch {
    return {};
  }
};

export const fetchProjectInspModels = async (projectId: number): Promise<InspModelItem[]> =>
  (await fetchInspModels()).filter((item) => parseInfo(item.info).project_id === projectId);
